module.exports = __webpack_public_path__ + "4b1774962d092578adbdccf2a825d94c.MP3";